<template>
    <div class="popup" v-cloak v-if="isShow">
        <div id="appRecommendMobile">
            <div class="app-recommend-mobile-close" @click="close()"></div>
            <div class="app-recommend-mobile-title">
                {{$t('language.popup.appRecommendPopup.modileTitle')}}
            </div>
            <div class="app-recommend-mobile-img" v-if="mobileType=='IOS'">
                <img src="../../../assets/images/appRecommend/app_ios_phone_mobile.png">
            </div>
            <div class="app-recommend-mobile-img" v-if="mobileType!='IOS'">
                <img src="../../../assets/images/appRecommend/app_android_phone_mobile.png">
            </div>
            <div class="app-recommend-mobile-tips" :style="mobileType=='IOS'?'padding: 12vw 0;':''" v-html="$t('language.popup.appRecommendPopup.tip')"></div>
            <div class="app-recommend-mobile-btns" v-if="mobileType=='IOS'">
                <div class="app-recommend-mobile-btn ios-btn" @click="jumpToIosDownload()">
                    <div class="app-recommend-mobile-btn-img"></div>
                    <div class="app-recommend-mobile-btn-tips">
                        <div class="app-recommend-mobile-btn-tip" v-if="getbtnType('ios')==1">{{$t('language.popup.appRecommendPopup.iosBtnTitle')}}</div>
                        <div class="app-recommend-mobile-btn-title">{{$t('language.popup.appRecommendPopup.iosBtnTip')}}</div>
                        <div class="app-recommend-mobile-btn-tip" v-if="getbtnType('ios')==2">{{$t('language.popup.appRecommendPopup.iosBtnTitle')}}</div>
                    </div>
                </div>
            </div>
            <div class="app-recommend-mobile-btns" v-if="mobileType!='IOS'">
                <div class="app-recommend-mobile-btn apk-btn" @click="jumpToAPKDownload()">
                    <div class="app-recommend-mobile-btn-img"></div>
                    <div class="app-recommend-mobile-btn-tips">
                        <div class="app-recommend-mobile-btn-tip" v-if="getbtnType('apk')==1">{{$t('language.popup.appRecommendPopup.apkBtnTitle')}}</div>
                        <div class="app-recommend-mobile-btn-title">{{$t('language.popup.appRecommendPopup.apkBtnTip')}}</div>
                        <div class="app-recommend-mobile-btn-tip" v-if="getbtnType('apk')==2">{{$t('language.popup.appRecommendPopup.apkBtnTitle')}}</div>
                    </div>
                </div>
                <div class="app-recommend-mobile-btn google-btn" @click="jumpToAndroidDownload()">
                    <div class="app-recommend-mobile-btn-img"></div>
                    <div class="app-recommend-mobile-btn-tips">
                        <div class="app-recommend-mobile-btn-tip" v-if="getbtnType('android')==1">{{$t('language.popup.appRecommendPopup.androidBtnTitle')}}</div>
                        <div class="app-recommend-mobile-btn-title">{{$t('language.popup.appRecommendPopup.androidBtnTip')}}</div>
                        <div class="app-recommend-mobile-btn-tip" v-if="getbtnType('android')==2">{{$t('language.popup.appRecommendPopup.androidBtnTitle')}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isShow: false,
            mobileType: "IOS",
        }
    },
    methods: {
        close(){
            this.isShow = false;
            this.$parent.$refs.rightContBan.showFunnel();
        },
        jumpToIosDownload(){
            window.open("https://apps.apple.com/cn/app/fonetool/id1620281509","_blank");
        },
        jumpToAPKDownload(){
            window.open("","_blank");
        },
        jumpToAndroidDownload(){
            window.open("https://play.google.com/store/apps/details?id=com.multcloud.mobile","_blank");
        },
        //判断是哪一种按钮样式
        getbtnType(type) {
            let lang = this.$i18n.locale;
            if(lang == 'japanese'){
                return 2;
            }
            if(lang == 'chinese' && type == 'ios'){
                return 2;
            }
            if(lang == 'traditionalChinese' && (type == 'ios' || type == 'android')){
                return 2;
            }
            return 1;
        },
    }
}
</script>

<style scoped>
.popup {
    z-index: 300;
}
#appRecommendMobile {
    width: 100%;
    height: 100vh;
    background: linear-gradient(360deg, #90A2F8 0%, #272AB0 100%);
    font-family: Arial;
    text-align: center;
    color: #FFFFFF;
}

.app-recommend-mobile-title {
    font-size: 0.6rem;
    font-weight: bold;
    line-height: 0.6rem;
    padding: 12vw 0 6vw;
}

.app-recommend-mobile-img{
    margin: auto;
}

.app-recommend-mobile-img img{
    width: 32vw;
}

.app-recommend-mobile-tips {
    font-size: 0.4rem;
    font-weight: 400;
    line-height: 0.5rem;
    padding: 6vw 0 6vw;
}

.app-recommend-mobile-btns {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.app-recommend-mobile-btn {
    border-radius: 0.2rem;
    min-height: 12vw;
    min-width: 48vw;
    display: inline-flex;
    margin: 2vw 0;
    cursor: pointer;
    background-color: #000000;
}

.app-recommend-mobile-btn-img{
    width: 7vw;
    margin: 0 3vw 0 6vw;
}

.apk-btn {
    background-color: #8CC43B;
}

.ios-btn .app-recommend-mobile-btn-img{
    background: url("../../../assets/images/appRecommend/logo_Apple_iphone.svg") no-repeat;
    background-size: 100% 100%;
}

.apk-btn .app-recommend-mobile-btn-img{
    background: url("../../../assets/images/appRecommend/icon_APK.svg") no-repeat;
    background-size: 100% 100%;
}

.google-btn .app-recommend-mobile-btn-img{
    background: url("../../../assets/images/appRecommend/icon_google_iphone.svg") no-repeat;
    background-size: 100% 100%;
}

.app-recommend-mobile-btn-tips {
    font-family: Arial;
    display: flex;
    flex-direction: column;
    text-align: left;
    padding: 1vw 3vw 2vw 0;
}

.app-recommend-mobile-btn-tip {
    font-size: 0.4rem;
    font-weight: 400;
    line-height: 0.4rem;
    margin-top: 0.2rem;
}

.app-recommend-mobile-btn-title {
    font-size: 0.6rem;
    margin-top: 0.2rem;
    line-height: 0.6rem;
    font-weight: bold;
}

.app-recommend-mobile-close {
    width: 0.6rem;
    height: 0.6rem;
    right: 3vw;
    top: 3vw;
    position: absolute;
    background: url("../../../assets/images/appRecommend/icon_close_mobile.png") no-repeat;
    cursor: pointer;
    background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/activity_popups/app_recommend_mobile_popup.vue